import { useRouter } from "next/router";
import React, { useCallback } from "react";

import { Loader } from "~/components/blocks";

import { Completed } from "./Completed";
import { SendPrescriptions } from "./SendPrescriptions";
import { StepName, StepNameMap } from "./SendPrescriptions/types";
import { useFetchPharmacy } from "./use-fetch-pharmacy";

type Query = {
  id?: string;
  step?: string;
};

export const Pharmacy = () => {
  const router = useRouter();
  const query = router.query as Query;

  const pharmacyId = query.id;

  const { loading, pharmacy } = useFetchPharmacy(pharmacyId);
  const enableReservation =
    pharmacy &&
    pharmacy.active &&
    pharmacy.webBookingsSetting.facetoface &&
    pharmacy.webBookingsSetting.published;

  const handleBackTop = useCallback(
    async () => await router.push("/"),
    [router],
  );
  const handleBackHistory = useCallback(() => router.back(), [router]);
  const handleChangeStep = useCallback(
    async (stepName: StepName) => {
      if (pharmacyId) {
        await router.push(`/pharmacies/${pharmacyId}?step=${stepName}`);
      }
    },
    [pharmacyId, router],
  );

  if (router.isReady && !query.id) {
    router.push("/404");
  }

  // useFetchPharmacyを呼び出しても APIリクエストがされない可能性があるため、pharmacyが存在した上でactiveかどうかを確認している
  if (router.isReady && !loading && pharmacy && !enableReservation) {
    router.push("/404");
  }

  if (loading) {
    return <Loader open />;
  }

  return query.step === StepNameMap.complete ? (
    <Completed onBack={handleBackTop} pharmacyId={query.id} />
  ) : (
    <SendPrescriptions
      pharmacyId={pharmacyId}
      currentStep={query.step}
      onBack={handleBackHistory}
      onChangeStep={handleChangeStep}
    />
  );
};
